module.exports = __webpack_public_path__ + "img/vi.8e871690.png";